import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import { useCookie } from 'react-use';

import { getClientCode, getSessionKey } from 'reducers/Login';

export function useSyncSessionToCookie() {
  const clientCode = useSelector(getClientCode);
  const sessionKey = useSelector(getSessionKey);
  const [cookie, setCookie] = useCookie(`apisession_${clientCode}`);
  useEffect(() => {
    if (!clientCode) return;
    if (!sessionKey) return;
    // If cookie from APi already exists, this has no effect
    // If cookie exists from us setting it before, let it be overridden to
    // so we don't end up with an expired key in the cookie
    setCookie(sessionKey, { domain: 'erply.com', secure: true });
  }, [clientCode, sessionKey, cookie, setCookie]);
}
